import SecureLSModule from 'secure-ls';

const SecureLS =
  (SecureLSModule as { default?: typeof SecureLSModule }).default ??
  SecureLSModule;

export default SecureLS;
